import { useTheme } from 'styled-components'
import useMediaQuery from '@mui/material/useMediaQuery'

/**
 * Custom hook to make all props in Grid system responsive.
 */
const useResponsive = () => {
  const theme = useTheme()

  const matches = {
    xs: useMediaQuery(theme.breakpoints.up('xs')),
    sm: useMediaQuery(theme.breakpoints.up('sm')),
    md: useMediaQuery(theme.breakpoints.up('md')),
    lg: useMediaQuery(theme.breakpoints.up('lg')),
    xl: useMediaQuery(theme.breakpoints.up('xl'))
  }

  return function (responsiveValues) {
    const [match] = theme.breakpoints.keys
      .filter(breakpoint => matches[breakpoint] && responsiveValues[breakpoint] != null)
      .reverse()

    return match && responsiveValues[match]
  }
}

export default useResponsive
